import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import it from "./it";
import en from "./en";

const translations = {
  it: {
    translation: it,
  },
  en: {
    translation: en,
  },
};

i18n.use(initReactI18next).init({
  lng: "it",
  fallbackLng: "it",
  resources: {
    ...translations,
  },
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
